<template>
    <div>
        <el-dialog :close-on-click-modal="clickClose" :model-value="dialogBoxData.state" :destroy-on-close="true" draggable @close="close"
                   :width="width?width:600" :top="top + 'vh'" :align-center="center" :style="'max-height: ' + dialogHeight + 'px'">
            <template #header>
                <div class="title">
                    {{dialogBoxData.title}}
                </div>
            </template>
            <el-scrollbar :max-height="(dialogHeight-220) + 'px'" >
                <template v-for="(item, index) in dialogBoxData.data" :key="index">
                    <div class="itemButton" @click.stop="itemClick(item, index)">{{item[dialogBoxData.prop]}}
                        <div v-if="dialogBoxData.select == index" class="item_ico">
                            <div class="item_check"></div>
                        </div>
                    </div>
                </template>
            </el-scrollbar>
        </el-dialog>
    </div>
</template>

<script>
    //region 对话框参数说明
    /*dialogBoxData: {
        state: true,                //组件展示状态
        title: '请选择您的公司',     //组件标题
        prop: 'companyName',        //选择展示文本的key
        select: 0,                  //已选择的
        data:{},                    //数据集合
        click: res => {             //点击回调
            console.log("选择返回", res);
        },
        close: res => {             //关闭回调
            console.log("关闭返回", res);
        }
    },*/
    //endregion

    export default {
        name: "dialogBox", //弹出对话窗口组件
        props: {
            //点击其他地方是否可以关闭页面
            clickClose:{
                type: Boolean,
                default: false
            },
            //窗口宽度
            width:{
                type: null,
                default: null
            },
            //窗口距顶部距离
            top:{
                type: Number,
                default: 15
            },
            //窗口是否上下左右居中
            center:{
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                dialogBoxData:{},
                dialogHeight: `${document.documentElement.clientHeight}`,
            }
        },
        methods:{

            /**
             * 行点击
             */
            itemClick(item, index){
                this.dialogBoxData.state = false;
                return this.dialogBoxData.click(item, index)
            },

            /**
             * 关闭回调
             */
            close(){
                this.dialogBoxData.state = false;
                return this.dialogBoxData.close();
            },

            /**
             * 初始化数据
             */
            initData(e){
                this.dialogBoxData = e;
            },
        },
        mounted() {
        }
    }
</script>

<style scoped>
    .title{
        font-weight: 800;
        font-size: 17px;
    }
    :deep(.el-dialog__header){
        border-bottom: 1px solid #f2f2f2;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
    :deep(.el-dialog__close) {
        font-size: 24px!important;
    }
    :deep(.el-dialog) {
        border-radius: 8px;
    }
    :deep(.el-button+.el-button) {
        color: #ffffff;
    }
    :deep(.el-form--inline .el-form-item){
        margin-right: 20px;
    }

    .itemButton{
        position: relative;
        left: 0;
        right: 0;
        margin: auto;
        width: 70%;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        background: #409eff;
        border-radius: 14px;
        font-weight: 800;
        font-size: 17px;
        margin-bottom: 20px;
        cursor: pointer;
    }
    .itemButton:hover{
        box-shadow: 0 0 0 1px #409eff inset;
        opacity: 0.8;
    }
    .item_ico{
        position: relative;
        top: 7px;
        border-radius: 50%;
        height: 28px;
        width: 28px;
        margin-bottom: 2px;
    }
    .item_check{
        width: 6px;
        height: 14px;
        border-color: #fff;
        border-style: solid;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        position: absolute;
        left: 10px;
    }

</style>
